/* eslint-disable @typescript-eslint/naming-convention */
export enum inputTypesEnum {
    text,
    html,
    template
}
